import { Pipe, PipeTransform } from '@angular/core';
const ticksToDate = require('ticks-to-date');

@Pipe({
  name: 'dateAgo',
})
export class DateAgoPipe implements PipeTransform {

  transform(tick: number, ...args: unknown[]): unknown {
    const intervals = [
      31536000,
      2592000,
      604800,
      86400,
      3600,
      60,
      1,
    ];
    const type = [
      'سال',
      'ماه',
      'هفته',
      'روز',
      'ساعت',
      'دقیقه',
      'ثانیه',
    ];
    const creationDate =  ticksToDate(tick);
    if (creationDate) {
      const seconds = Math.floor((+new Date() -  +creationDate) / 1000);
      if(seconds > 0) {
        let counter;
        for(let index = 0 ; index < intervals.length; index++) {
          counter = Math.floor(seconds / intervals[index]);
          if(counter > 0) {
            return counter.toString() + ' ' + type[index] + ' پیش';
          }
        }
      } else {
        return 'هم‌اکنون';
      }
    }
    return creationDate;
  }

}
